import React from "react";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <>
      <section className="footer_pading">
        <div className="container">
          <div className="row g-lg-0 g-3">
            <div className="col-lg-4">
              <h6 className="font_22 mb-lg-4 mb-3 fw-bold ">Mission</h6>
              <p className="heading-4 text-secondary">
                Adding velocity to your TechOps, helping you achieve more.
              </p>
            </div>
            <div className="col-lg-2 col-md-4 col-6 offset-lg-1">
              <h6 className="font_22 mb-lg-4 mb-3 fw-bold">Company</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href="/"
                    className="text-decoration-none text_grey font_14"
                  >
                    Company
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Diversity Statement
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Startups
                  </a>
                </li>
                <li className="mb-2">
                  <Link
                    to="/contact"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4 col-6 ">
              <h6 className="font_22 mb-lg-4 mb-3 fw-bold">Services</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Blockchain & DeFi
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Artificial intelligence
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Gaming
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Web3 & Metaverse
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Marketing
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Exchange
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Trading Bot
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    M | M
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4 col-6">
              <h6 className="font_22 mb-lg-4 mb-3 fw-bold">Recent Projects</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Blockchain & DeFi
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Fundabl
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Gaming
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Lovechain
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    GotoApp
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Augusta
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Ask a vet
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Outstaffer
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-12 mt-0">
              <div className="d-flex gap-2 align-items-center">
                <a href="/" className="">
                  <img
                    src="assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                    alt="linkdin"
                    className="image-3"
                  />
                </a>
                <a href="/" className="">
                  <img
                    src="assets/img/639b830a4cbdd20fd5f3a9a9/twitter.svg"
                    alt="LinkedIn Link"
                    className="image-3 mt-1"
                  />
                </a>
              </div>
            </div>
            <div className="col-12 mt-0">
              <div className="d-flex flex-wrap align-items-center gap-4 my-4">
                <div className="font_12 text-secondary">© blockcryp 2024</div>
                <div className="d-flex align-items-center gap-4">
                  <a
                    href="/"
                    className="text-decoration-none font_12 text-secondary"
                  >
                    Privacy policy
                  </a>
                  <span className="text-muted">|</span>
                  <a
                    href="/"
                    className="text-decoration-none font_12 text-secondary"
                  >
                    Terms of Use
                  </a>
                  <span className="text-muted">|</span>
                  <a
                    href="/"
                    className="text-decoration-none font_12 text-secondary"
                  >
                    Cookies
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
